import type { usePostHog } from "@posthog/next";
import { applyRealtimeModelUpgrade, RealtimeModelUpgradeError } from "@/services/realtimeModel/client";

type Analytics = Pick<ReturnType<typeof usePostHog>, "capture"> | undefined;

/** Fire-and-forget: never throws, never rejects, and reports only to analytics. */
export function triggerRealtimeModelUpgrade(posthog: Analytics): void {
  void applyRealtimeModelUpgrade().then(
    ({ tier, model }) => {
      posthog?.capture("realtime_model_upgraded", { tier, model });
    },
    (error: unknown) => {
      const status = error instanceof RealtimeModelUpgradeError ? error.status : 0;
      posthog?.capture("realtime_model_upgrade_failed", { status });
    }
  );
}
